import { WorkoutExercise } from "../../workout/types";
import {
  BodypartType,
  ExerciseTagDto,
  MovementPatternType,
} from "@growth-machine-llc/stridist-api-client";
import {
  UPDATE_EXERCISE_MESSAGE,
  useUpdateLibraryExercise,
} from "./useUpdateLibraryExercise";
import {
  CREATE_EXERCISE_MESSAGE,
  useCreateLibraryExercise,
} from "./useCreateLibraryExercise";
import { useValidateBodyparts } from "./useValidateBodypart";

export type Options = {
  onCompleted?: (exerciseId?: number) => void;
};

export interface Exercise {
  id: number;
  exercise: WorkoutExercise;
  bodyparts: BodypartType[];
  movementPatterns: MovementPatternType[];
  tagIds?: number[];
}

//TODO_exercise_drawer: use in new the exercise library. Try to create a generic hook for the editor exercise drawer and the library
export function useSaveExerciseLibraryAsset(
  createNewAsset: boolean,
  exerciseTags?: ExerciseTagDto[],
  allowEmptyBodyparts = false,
  createMessage: string = CREATE_EXERCISE_MESSAGE,
  updateMessage: string = UPDATE_EXERCISE_MESSAGE,
) {
  const validateBodyparts = useValidateBodyparts();

  const { mutate: createAsset, isPending: isCreatePending } =
    useCreateLibraryExercise(exerciseTags, createMessage);

  const { mutate: updateAsset, isPending: isUpdatePending } =
    useUpdateLibraryExercise(exerciseTags, updateMessage);

  const saveLibraryExercise = (
    { id, exercise, bodyparts, movementPatterns, tagIds }: Exercise,
    options?: Options,
  ) => {
    const content = JSON.stringify(exercise);

    if (!allowEmptyBodyparts) {
      const isValid = validateBodyparts(bodyparts);
      if (!isValid) return;
    }

    return createNewAsset
      ? createAsset(
          {
            name: exercise.title,
            content,
            bodyparts,
            movementPatterns,
            tagIds,
          },
          {
            onSuccess: (assetId: number) => {
              options?.onCompleted?.(assetId);
            },
          },
        )
      : updateAsset(
          {
            id,
            name: exercise.title,
            content,
            bodyparts,
            movementPatterns,
            tagIds,
          },
          {
            onSuccess: () => {
              options?.onCompleted?.();
            },
          },
        );
  };

  return {
    saveLibraryExercise,
    isPending: createNewAsset ? isCreatePending : isUpdatePending,
  };
}
